/**
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.org) All Rights Reserved.
 *
 * WSO2 Inc. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 *
 */

import { ModuleWithProviders, NgModule } from "@angular/core";
import { AsgardeoSignInRedirectComponent } from "./components/asgardeo-sign-in-redirect.component";
import { ASGARDEO_CONFIG } from "./configs/asgardeo-config";
import { AsgardeoAuthGuard } from "./guards/asgardeo-auth.guard";
import { AsgardeoConfigInterface } from "./models";
import { AsgardeoAuthService } from "./services";

@NgModule({
    declarations: [AsgardeoSignInRedirectComponent]
})
export class AsgardeoAuthModule {
    static forRoot(config: AsgardeoConfigInterface): ModuleWithProviders<AsgardeoAuthModule> {
        return {
            ngModule: AsgardeoAuthModule,
            providers: [
                AsgardeoAuthService,
                AsgardeoAuthGuard,
                {
                    provide: ASGARDEO_CONFIG,
                    useValue: config
                }
            ]
        };
    }
}
